import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { LOAD_STORED_STATE, type LoadStoredStateAction } from './constants';

export interface TableConfigType {
  size: 'large' | 'middle' | 'small';
}

export interface ManageLeadsState {
  isAdvancedSearchOpen: boolean;
  isEmailOpen: boolean;
  sidebarVisible: boolean;
  page: number;
  leadList: {
    itemsPerPage: number;
    visibleColumnsV1?: string[];
    tableConfig: TableConfigType;
  }
}

const initialState: ManageLeadsState = {
  isAdvancedSearchOpen: false,
  isEmailOpen: false,
  sidebarVisible: true,
  page: 1,
  leadList: {
    itemsPerPage: 10,
    visibleColumnsV1: [],
    tableConfig: {
      size: 'large',
    },
  },
};

export const leadListSlice = createSlice({
  name: 'listDetail/leadList',
  initialState: { ...initialState },
  reducers: {
    toggleAdvancedSearch: (state) => {
      state.isAdvancedSearchOpen = !state.isAdvancedSearchOpen;
    },
    toggleEmail: (state) => {
      state.isEmailOpen = !state.isEmailOpen;
    },
    toggleSidebar: (state) => {
      state.sidebarVisible = !state.sidebarVisible;
    },
    updateItemsPerPage: (state, action: PayloadAction<number>) => {
      state.leadList.itemsPerPage = action.payload;
    },
    updateCurrentPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    resetCurrentPage: (state) => {
      state.page = initialState.page;
    },
    updateTableConfig: (state, action: PayloadAction<Partial<TableConfigType>>) => {
      state.leadList.tableConfig = {
        ...state.leadList.tableConfig,
        ...action.payload,
      };
    },
    setVisibleColumns: (state, action: PayloadAction<string[]>) => {
      state.leadList.visibleColumnsV1 = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(LOAD_STORED_STATE, (_, action: LoadStoredStateAction) => ({
      ...initialState,
      ...action.payload.leadList,
    }));
  },
});

export const {
  toggleAdvancedSearch,
  toggleEmail,
  toggleSidebar,
  updateItemsPerPage,
  updateCurrentPage,
  resetCurrentPage,
  updateTableConfig,
  setVisibleColumns,
} = leadListSlice.actions;

export default leadListSlice.reducer;
